import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import {triggerBo} from '../../../../../containers/SRP/redux/thunks'
import * as S from "./SliderFilter.ts";

var filterCardClear = false, resetBoState = false

const SliderCard = forwardRef((props, ref) => {
  const { filter_cards, onFilterCardClick, refs } = props
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slState, setSlState] = React.useState<any | null>({
    hasViewed: false,
    hasClicked: false
  })
 
  let viewAttributeUrl =
    filter_cards[0]?.metaData?.adData?.viewUrl
  let clickAttributeUrl =
  filter_cards[0]?.metaData?.adData?.clickUrl
  const is_sponsored = viewAttributeUrl !== '' ? true : false
  
  const trackSlViewed = () => {
    setSlState((prevSlState: any) => {
      if (!prevSlState?.hasViewed && viewAttributeUrl && sessionStorage.getItem('BO_AD_VIEW') !== viewAttributeUrl) {
        triggerBo(filter_cards[0]?.metaData?.adData, 'BO_AD_VIEW')
        return {
          ...prevSlState,
          hasViewed: true
        }
      }
      return prevSlState
    })
  }

  const trackBusClick = () => {
 if (!slState.hasClicked && clickAttributeUrl && sessionStorage.getItem('BO_AD_CLICK') !== clickAttributeUrl) {
      triggerBo(filter_cards[0]?.metaData?.adData, 'BO_AD_CLICK')
      setSlState({
        ...slState,
        hasClicked: true
      })
    }
    return true
  }

  useEffect(()=>{
    trackSlViewed()
  },[viewAttributeUrl])

  const handleLeftClick = () => {
    // Navigate to the previous card
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleRightClick = () => {
    // Navigate to the next card
    if (currentIndex < filter_cards.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const [activeTab, setActiveTab] = useState(-1);

  const handleTabClick = (e, index, cardName, cardType) => {
    e.preventDefault();
    setActiveTab(index);
    if(cardType === 'BO_ADS'){
        if(index === activeTab){
          setActiveTab(-1)
          onFilterCardClick(cardName, '',false)
        }else{
          onFilterCardClick(cardName, 'operator', true)
        }
        trackBusClick()
    }else{
      if(index === activeTab){
        setActiveTab(-1)
        onFilterCardClick(cardName, '',false)
      }else{
        onFilterCardClick(cardName, 'popular',false)
      }
    }
  };
  useEffect(()=>{
    if(filterCardClear){
       setActiveTab(-1)
       filterCardClear = !filterCardClear
      }
      if(resetBoState){
        setSlState({
          hasViewed: false,
          hasClicked: false
        })
      }
  },[filterCardClear, resetBoState])
  return (
    <S.SliderCard>
      <button className='button-left' onClick={handleLeftClick} disabled={currentIndex === 0}>
        <img className="rightArrow" src="https://gos3.ibcdn.com/rightArrow-1695887622.png" />
      </button>
      <div className="card-container">
        {filter_cards.map((tab, index) => 
        {
    
        return(
          <>
          <div
            key={index}
            className={`tabItem ${index === activeTab ? 'active' : ''}`}
            onClick={(e) => handleTabClick(e, index, tab.k,tab.type)}
            style={{
              transform: `translateX(-${currentIndex * 120}%)`,
              background: tab.bgColor[0],
              width: 'auto',
              opacity: activeTab === -1 || index === activeTab ? 1 : 0.6,
              maxWidth: '200px'
            }}>
              {
                tab.type !== "BO_ADS" && 
                <>
                <img className='bgImage' src={tab.imgUrl.close} />
                <img className='redirectImg' src="https://gos3.ibcdn.com/rightArrowBtn-1695887535.png" />
                </>

              }
             
            {
              tab.type === "BO_ADS" ?
                <img className='adDimention' src={tab.imgUrl.close} /> :
                <div className='cardWrapper'>
                  <p className='heading'>{tab.title}</p>
                  <p className='discText'>{tab.subTitle}</p>
                </div>
            }
           
           {
              index === activeTab ?
              <img src="https://gos3.ibcdn.com/activeFilter-1695887555.png" className='tickIcon'/>: ""
            }
          </div>
          </>
        )})}
      </div>
      {
        filter_cards &&
      <button className='button-right' onClick={handleRightClick} disabled={currentIndex === filter_cards.length - 4}>
      <img className="rightArrow" src="https://gos3.ibcdn.com/rightArrow-1695887622.png" />
      </button>}
    </S.SliderCard>
  );
});

export default SliderCard;

export const clearFilterCard = (resetBoStateParam) => {
  filterCardClear = !filterCardClear
  resetBoState = resetBoStateParam ? true : false
}